import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import BackgroundVideo from "./components/BackgroundVideo";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Pricing from "./pages/Pricing";
import Schedule from "./pages/Schedule";

const App = () => {
  return (
    <Router>
      <div className="relative min-h-screen flex flex-col">
        <BackgroundVideo />
        <Header />
        <main className="flex-grow flex flex-col justify-center items-center">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<AboutUs />} />
            <Route path="/prezzi" element={<Pricing />} />
            <Route path="/orari" element={<Schedule />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
